<div class="container d-flex flex-wrap justify-content-center">
  @if (!!trainings && trainings.length > 0) {
    @for (training of trainings; track trackTraining($index, training)) {
      <app-training-card class="card p-3" [training]="training"></app-training-card>
    }
  } @else {
    <div class="justify-content-center text-center flex-grow-1 align-items-center p-5 empty" translate>SEARCH.EMPTY_RESULT</div>
  }
</div>
